import { UserLoginModel } from '@models/outros/user-login.model';
import { menuConfig } from '@constants/menu.constants';
import { UserControllerService } from './user-controller.service';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { LocalStorageService } from 'ngx-webstorage';
import { Variables } from '@core/utils/variables';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private _menusAtual$ = new BehaviorSubject<MenuConfigModel[]>(new Array<MenuConfigModel>());

  constructor(
    private _user: UserControllerService,
    private _storage: LocalStorageService
  ) {
    this._storage.store(Variables.MENU, menuConfig);
  }

  setMenu() {
    let menu = Object.assign([], JSON.parse(JSON.stringify(this._storage.retrieve(Variables.MENU))));
    let user: UserLoginModel = this._user.getUserLogged();

    if (!this._user.isAssociado()) {
      menu = menu.filter(x => !x.onlyAssociated && !x.disabled);
      menu.forEach(
        (element) => {
          element.submenus = element.submenus.filter(x => !x.onlyAssociated && !x.disabled);
        }
      );
    } else {
      menu = menu.filter(x => x.profilesToShowItems.includes(user.type) && !x.disabled);
      menu.forEach(
        (element) => {
          let submenu = [];
          element.submenus.forEach(
            (y) => {
              if (y.profilesToShowItems.includes(user.type) && !y.disabled) {
                submenu.push(y)
              }
            }
          )
          element.submenus = submenu;
        }
      );
    }
    this._menusAtual$.next(menu)
  }

  getMenuAtual(): Observable<MenuConfigModel[]> {
    return this._menusAtual$.asObservable();
  }
}
